import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { CookieService } from 'ngx-cookie-service';
import { Observable, of } from 'rxjs';
import jwtDecode from 'jwt-decode';
import { AuthToken } from '../models/auth-token';
import { JwtPayload } from '../models/jwtPayload';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  private readonly ACCESS_TOKEN_KEY = environment.cookieName;

  constructor(
    private cookieService: CookieService,
  ) { }

  public getTokenUserCredentials(): Observable<string> {
    const token = this.cookieService.get(this.ACCESS_TOKEN_KEY);
    return of(token);
  }

  public clearTokenUserCredentials(): void {
    this.cookieService.delete(this.ACCESS_TOKEN_KEY, '/');
  }

  public decodeToken(token: string): Observable<AuthToken | undefined> {
    const payload = jwtDecode<JwtPayload>(token);

    const authToken: AuthToken = {
      tokenString: token,
      expiresAt: moment.unix(payload.exp!).utcOffset(-3),
      cpf: payload.name,
      actor: payload.actort,
      roles: this.transformRoles(payload.role)
    };

    return of(authToken);
  }

  private transformRoles(roles: any): string[] {
    if (!roles) {
      return [];
    } else if (typeof roles == 'string') {
      return [roles];
    } else {
      return roles;
    }
  }
}
